import { Component, OnInit, Output ,EventEmitter} from '@angular/core';
import { ValidatorPasswordService } from "./validator-password.service";
import { Subscription } from "rxjs";
@Component({
  selector: 'app-password-validator',
  templateUrl: './password-validator.component.html',
  styleUrls: ['./password-validator.component.sass']
})
export class PasswordValidatorComponent implements OnInit {

  public validator:boolean=false;
  public capitalLetter:boolean=false;
  public lowerCase:boolean=false;
  public specialCharacterNumber:boolean=false;
  public characterLength:boolean=false;

  passwordObserver: Subscription;
  @Output() validatePassword = new EventEmitter<any>();
  constructor(private validatorPasswordService: ValidatorPasswordService) { }

  ngOnInit() {
    this.passwordObserver = this.validatorPasswordService.status.subscribe((value:string) => {
      this.onKey(value);
    });
  }
  onKey(pswd){
    
    let sw:boolean=false;
    this.validator=false;
    this.capitalLetter=false;
    this.lowerCase=false;
    this.specialCharacterNumber=false;
    this.characterLength=false;

    if (pswd.length < 8) {
      sw=true;
    } 
    else {
      this.characterLength=true;
    }

    if (pswd.match(/[a-z]/)) {
       this.lowerCase=true;
    } 
    else {
      sw=true;
    }

    if (pswd.match(/[A-Z]/)) {
      this.capitalLetter=true;
    } 
    else {
      sw=true;
    }
  
    if (pswd.match(/\d/) || pswd.match(/\W/) || pswd.match(/[0-9]/)) {   
      this.specialCharacterNumber=true;
    } 
    else {
      sw=true;
    }
    if(sw==true){
      this.validator=true;
    }
    this.validatePassword.emit(sw);
  }
}
